module.exports = __webpack_public_path__ + "static/media/empty_logo.2b801d59.svg";